import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data - Linehaul Workstream
 * Matches the actual API response structure
 */
export const mockSentryIssuesLinehaul = {
  success: true,
  issues: [
    {
      id: '6843177801',
      title: "TypeError: Cannot read property 'tripId' of undefined",
      culprit: '/linehaul/trips-dashboard/trip-details',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'TypeError',
        value: "Cannot read property 'tripId' of undefined",
        type: 'TypeError',
        filename: 'TripDetails.tsx',
        function: 'loadTripData',
        in_app_frame_mix: 'mixed-frames',
      },
      numComments: 2,
      userCount: 8,
      count: 45,
      firstSeen: dayjs().subtract(2, 'months').toISOString(),
      lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177801/',
      shortId: 'LINEHAUL-1A1',
      project: {
        id: '4507465295659001',
        name: 'linehaul',
        slug: 'linehaul',
        platform: 'javascript-react',
      },
      assignedTo: {
        type: 'user',
        name: 'John Doe',
        email: 'john.doe@daylight.com',
      },
      isBookmarked: false,
      isSubscribed: true,
      isUnhandled: true,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 45,
        userCount: 8,
        firstSeen: dayjs().subtract(2, 'months').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      lifetime: {
        count: 45,
        userCount: 8,
        firstSeen: dayjs().subtract(2, 'months').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177802',
      title: 'ReferenceError: shipmentData is not defined',
      culprit: '/linehaul/shipments/list',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'ReferenceError',
        value: 'shipmentData is not defined',
        type: 'ReferenceError',
        filename: 'ShipmentList.tsx',
        function: 'renderShipments',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 0,
      userCount: 5,
      count: 32,
      firstSeen: dayjs().subtract(1, 'month').toISOString(),
      lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177802/',
      shortId: 'LINEHAUL-2B2',
      project: {
        id: '4507465295659001',
        name: 'linehaul',
        slug: 'linehaul',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: true,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 32,
        userCount: 5,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      },
      lifetime: {
        count: 32,
        userCount: 5,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(3, 'hours').toISOString(),
      },
      enrichedEnvironment: 'QA',
    },
    {
      id: '6843177803',
      title: 'Network Error: Failed to fetch route data',
      culprit: '/linehaul/routes/optimizer',
      status: 'unresolved',
      level: 'warning',
      type: 'error',
      metadata: {
        title: 'AxiosError',
        value: 'Network Error',
        type: 'AxiosError',
        filename: 'axios/lib/core/Axios.js',
        function: 'handleError',
        in_app_frame_mix: 'system-only',
      },
      numComments: 1,
      userCount: 12,
      count: 68,
      firstSeen: dayjs().subtract(3, 'months').toISOString(),
      lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177803/',
      shortId: 'LINEHAUL-3C3',
      project: {
        id: '4507465295659001',
        name: 'linehaul',
        slug: 'linehaul',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: false,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'low',
      filtered: {
        count: 68,
        userCount: 12,
        firstSeen: dayjs().subtract(3, 'months').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      lifetime: {
        count: 68,
        userCount: 12,
        firstSeen: dayjs().subtract(3, 'months').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 3,
  },
  'x-hits': 3,
  recordCount: 3,
}

export const mockPriorityCountsLinehaul = {
  success: true,
  'priority-counts': {
    high: 1,
    medium: 1,
    low: 1,
  },
  'x-hits': 3,
}
